const state = {
  brands: [],
  brandImages: []
}

const mutations = {
  RESET_BRANDS: function (state) {
    state.brands = [];
    state.brandImages = [];
  },
  ADD_BRAND: function (state, brand) {
    if (state.brands.findIndex(b => {
      return b.id === brand.id
    }) === -1) {
      state.brands.push(brand);
    }
  },
  SET_BRAND_IMAGES: function (state, images) {
    state.brandImages = images;
  },
}

const actions = {

  downloadBrands({ commit, rootState }, categories) {

    return new Promise(resolve => {

      let temp = [];

      categories.forEach(cat => {
        if (temp.findIndex(t => { return t === cat.brand }) === -1) {
          temp.push(cat.brand)
        }
      })

      let promiseArray = temp.map(b => {
        return rootState.Database.db
          .collection("brands")
          .doc(b)
          .get()
          .then(function (doc) {
            if (doc.exists) {
              let data = doc.data();
              data["id"] = doc.id;
              commit('ADD_BRAND', data);
            }
          })
      })
      Promise.all(promiseArray).then(() => {
        resolve(true);
      })
    })
  },

  initializeBrands({ dispatch, commit, state, rootState }) {

    return new Promise(resolve => {
      let imgArr = []

      dispatch('downloadBrands', rootState.Categories.categories)
        .then(() => {
          state.brands.forEach(element => {
            rootState.Database.storage.refFromURL(element.icon).getDownloadURL().then(function (url) {
              var xhr = new XMLHttpRequest();
              xhr.responseType = 'blob';
              xhr.onload = function (event) {
                var blob = xhr.response;
              };
              xhr.open('GET', url);
              xhr.send();
              imgArr.push({ id: element.id, image: url });
              commit('SET_BRAND_IMAGES', imgArr)
            }).catch(function (error) {
              // Handle any errors
            });
          });
          resolve(true);
        })
    })
  }


}

const getters = {
  getBrands(state) {
    if (state.brands.length > 0) {
      return state.brands
    }
    else {
      return []
    }
  },
  getBrandById(state, id) {
    return state.brands.find((brand) => {
      return brand.id == id;
    })
  },
  getBrandImages(state) {
    if (state.brandImages != null) {
      return state.brandImages
    }
    else {
      return []
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
} 



// WEBPACK FOOTER //
// ./src/store/modules/Brands.js